import { useMutation, UseMutationOptions } from "react-query";
import { getConfig } from "../config";

export async function createOrder(data: Order) {
  const { apiUrl, apiKey } = getConfig();
  const url = `${apiUrl}/orders/orders/`;
  const headers = {
    "X-Locker-Token": apiKey,
    "Content-Type": "application/json",
  };
  const response = await fetch(url, {
    headers,
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Network Error");
  }
  return response.json();
}

export function useCreateOrder(options?: UseMutationOptions) {
  return useMutation((data: Order) => createOrder(data), options as any);
}
